
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/permissions",
      function () {
        return require("private-next-pages/ai-decisioning/permissions.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/permissions"])
      });
    }
  